/**
 * Calendar-day cache for the dashboard "המובילים של החודש" card.
 * Hydrate synchronously on mount; refresh only when the local day rolls over (midnight).
 */

import { resolveHomeDashboardCacheAgentKey } from "./homeDashboardCache";
import {
  localCalendarDayKey,
  msUntilNextLocalMidnight,
} from "./billingExemptionDailyCache";

const CACHE_PREFIX = "hr_top_agents_month_day_v1_";

export { resolveHomeDashboardCacheAgentKey as resolveTopAgentsCacheAgentKey };
export { localCalendarDayKey, msUntilNextLocalMidnight };

function cacheKey(agentKey) {
  return `${CACHE_PREFIX}${String(agentKey || "anon").trim().toLowerCase()}`;
}

/**
 * @returns {{
 *   dayKey: string,
 *   savedAt: number,
 *   month: string,
 *   payload: object,
 * } | null}
 */
export function readTopAgentsOfMonthDailyCache(
  agentKey,
  month,
  now = new Date()
) {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(cacheKey(agentKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    const dayKey = String(parsed.dayKey || "").trim();
    if (!dayKey || dayKey !== localCalendarDayKey(now)) return null;
    const cachedMonth = String(parsed.month || "").trim();
    const wantMonth = String(month || "").trim();
    if (wantMonth && cachedMonth && cachedMonth !== wantMonth) return null;
    if (!parsed.payload || typeof parsed.payload !== "object") return null;
    return {
      dayKey,
      savedAt: Number(parsed.savedAt) || 0,
      month: cachedMonth || wantMonth,
      payload: parsed.payload,
    };
  } catch {
    return null;
  }
}

export function writeTopAgentsOfMonthDailyCache(
  agentKey,
  month,
  payload,
  now = new Date()
) {
  if (typeof window === "undefined") return;
  if (!payload || typeof payload !== "object") return;
  try {
    const body = {
      dayKey: localCalendarDayKey(now),
      savedAt: Date.now(),
      month: String(month || payload.month || "").trim(),
      payload,
    };
    window.localStorage.setItem(cacheKey(agentKey), JSON.stringify(body));
  } catch {
    // quota / private mode — ignore
  }
}

export function clearTopAgentsOfMonthDailyCache(agentKey) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(cacheKey(agentKey));
  } catch {
    /* ignore */
  }
}
